<template>
  <div class="flex w-full flex-col">
    <div
      class="flex w-full flex-col bg-gray-900 px-4 py-8 text-white md:flex-row md:px-36 md:py-16"
    >
      <div class="flex space-x-8 pb-2 md:space-x-28">
        <template v-for="column in navigationColumns" :key="column.name">
          <SFFooterNavColumn
            v-if="column.name !== t('footer.legal_notices')"
            :column="column"
          />
        </template>
      </div>
      <div class="my-8 border-t border-gray-300 md:border-t-0"></div>
      <div class="ml-0 md:ml-28 md:mt-0">
        <SFFooterPaymentSection :payments="payments" />
      </div>
    </div>
    <div :class="{ 'mt-6': showCopyright }" class="px-4 md:px-36">
      <div
        v-if="showCopyright"
        class="mr-auto text-gray-900"
        data-testid="footer-copyright"
      >
        {{ $t('footer.copyright', { currentYear: new Date().getFullYear() }) }}
      </div>
      <ul class="flex flex-row gap-4 text-gray-600 md:contents">
        <li
          v-for="navItem in footerTree?.items"
          :key="`footer-link-${navItem.id}`"
        >
          <SFNavigationTreeItem
            :navigation-item="navItem"
            class="rounded-md hover:bg-gray-100 md:p-1"
            data-testid="simple-footer-link"
            raw
          />
        </li>
      </ul>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useSimpleFooterNavigation } from '#storefront-navigation/composables'
import SFNavigationTreeItem from '~/components/SFNavigationTreeItem.vue'
import SFFooterNavColumn from '~/components/footer/SFFooterNavColumn.vue'
import { useFooterData } from '~/composables/useFooterData'
import { useI18n } from '#i18n'
import SFFooterPaymentSection from '~/components/footer/SFFooterPaymentSection.vue'

withDefaults(
  defineProps<{
    showCopyright?: boolean
  }>(),
  {
    showCopyright: true,
  },
)

const { data: footerTree } = useSimpleFooterNavigation()
const { t } = useI18n()
const { navigationColumns, payments } = await useFooterData({
  with: { category: false },
})
</script>
